module.exports = __webpack_public_path__ + "img/auth_step_1.08d07ae2.png";